export const uk = {
    BYN: 'BYN',
    CHF: '₣',
    EUR: '€',
    KZT: '₸',
    RUB: '₽',
    TRY: '₺',
    UAH: '₴',
    USD: '$',
    UZS: 'UZS',
    YND_FIXED: 'у.е.'
};
